import styled from "@emotion/styled";
import { media, SolidButton } from "@iventis/styles";
import { Content } from "@iventis/translations";
import React from "react";

export const MobileCommentsButtons = ({ handleCancelClick, handleMoveClick, translate }) => (
    <StyledMobileCommentsButtonWrapper>
        <StyledSolidButton data-testid="cancel-move-comment-button" variant="outlined" onClick={handleCancelClick}>
            {translate(Content.common.buttons.cancel)}
        </StyledSolidButton>
        <SolidButton data-testid="confirm-move-comment-button" onClick={handleMoveClick}>
            {translate(Content.comments.moveComments)}
        </SolidButton>
    </StyledMobileCommentsButtonWrapper>
);

const StyledMobileCommentsButtonWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 40px;
    bottom: 40px;
    right: 10px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    > button {
        height: 48px;
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);
        ${media.extraSmall} {
            padding-left: 10px;
            padding-right: 10px;
        }
    }

    ${media.extraExtraSmall} {
        right: 5px;
        gap: 5px;
    }

    ${media.small} {
        right: 30px;
    }
`;

const StyledSolidButton = styled(SolidButton)`
    &,
    &:hover,
    &:focus {
        background: ${({ theme }) => theme.secondaryColors.blank};
    }
`;
